import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { AdminMainSidebarProps } from './props'
import { Link, useLocation } from 'react-router'
import links from '../../../routes/links'
import navs from './navs'
import { Fragment } from 'react/jsx-runtime'
import { DeltaCoreXLogo } from '../../../assets/icons'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import adminPagesStore from '../../../store/adminPagesStore'
import authStore from '../../../store/authStore'
import LogoutIcon from '@mui/icons-material/Logout'
import AuthService from '../../../services/auth'

const scopeNamePrefix = 'admin-main-sidebar'
const boxBg = 'rgba(255,255,255,70%)'

export default function AdminMainSidebar(props: AdminMainSidebarProps) {
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))
  const location = useLocation()
  const user = authStore(state => state.user)

  return (
    <Paper
      elevation={3}
      sx={{
        width: props.sidebarWidth,
        height: '100vh',
        position: 'fixed',
        borderRadius: 0,
        bgcolor: theme.palette.primary.dark,
        zIndex: 100,
        ...props.sx,
      }}
    >
      <Stack direction='column' sx={{ height: '100%' }}>
        <Stack direction='row' gap={2} sx={{ p: 2 }}>
          <Link to={links.admin.dashboard()} style={{ flexGrow: 1 }}>
            <Card sx={{ bgcolor: boxBg }}>
              <CardActionArea sx={{ px: 1, pt: 0.5 }}>
                <DeltaCoreXLogo width={(221 / 3) * 2} height={(96 / 3) * 2} />
              </CardActionArea>
            </Card>
          </Link>
          {upMd ? null : (
            <Button
              color='secondary'
              variant='contained'
              size='small'
              sx={{ borderRadius: 4 }}
              onClick={() => adminPagesStore.setState({ openSidebar: false })}
            >
              <ArrowBackIosNewIcon />
            </Button>
          )}
        </Stack>
        <Box sx={{ flexGrow: 1 }}>
          <List>
            {navs.map((nav, navIndex) => (
              <Fragment key={`${scopeNamePrefix}-navs-item-${navIndex}`}>
                <ListItem sx={{ color: theme.palette.primary.contrastText }}>
                  <ListItemText>
                    <Typography fontWeight={800}>{nav.label}</Typography>
                  </ListItemText>
                </ListItem>
                {nav.items?.map((navItem, navItemIndex) => (
                  <Link
                    key={`${scopeNamePrefix}-navs-item-${navIndex}-item-${navItemIndex}`}
                    to={navItem.link ?? ''}
                    style={{ textDecoration: 'none' }}
                  >
                    <ListItemButton
                      sx={{
                        bgcolor: location.pathname === navItem.link ? theme.palette.primary.light : undefined,
                        ':hover': { bgcolor: theme.palette.primary.light },
                      }}
                    >
                      {!!navItem.icon ? (
                        <ListItemIcon sx={{ color: theme.palette.primary.contrastText }}>{navItem.icon}</ListItemIcon>
                      ) : null}
                      <ListItemText sx={{ color: theme.palette.primary.contrastText }}>{navItem.label}</ListItemText>
                    </ListItemButton>
                  </Link>
                ))}
              </Fragment>
            ))}
          </List>
        </Box>
        <Paper sx={{ bgcolor: boxBg, px: 1, py: 1, m: 1 }}>
          <Stack direction={'row'} alignItems={'center'} justifyContent={'start'} gap={1}>
            <Avatar
              alt={user?.photoURL ?? user?.displayName ?? user?.email ?? ''}
              src={user?.photoURL ?? user?.displayName ?? user?.email ?? ''}
              slotProps={{ img: { referrerPolicy: 'no-referrer' } }}
            />
            <Box>
              <Typography variant='h6'>{user?.displayName}</Typography>
              <Typography>{user?.email}</Typography>
            </Box>
          </Stack>
          <Button
            variant='outlined'
            fullWidth
            size='small'
            startIcon={<LogoutIcon />}
            sx={{ mt: 1 }}
            onClick={AuthService.firebaseLogout}
          >
            Logout
          </Button>
        </Paper>
      </Stack>
    </Paper>
  )
}
